import { axiosClientWithTenantId } from 'AxiosClientProvider'

import type { BucketListResponse, DeleteWorkResultsParams, UploadUrlRequestBody, UploadUrlResponse } from './types'

export const getBuckets = async (): Promise<BucketListResponse> => {
  const url = '/buckets'

  const response = await axiosClientWithTenantId.get(url)
  return response.data
}

export const getUploadUrl = async (data: UploadUrlRequestBody): Promise<UploadUrlResponse> => {
  const url = '/upload-url'

  const response = await axiosClientWithTenantId.post(url, data)
  return response.data
}

export const deleteWorkResults = async (params: DeleteWorkResultsParams): Promise<void> => {
  const url = '/upload-work-results'

  await axiosClientWithTenantId.delete(url, { params })
}
